// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-64a59a56], .fade-leave-active[data-v-64a59a56] {\n  transition: all 0.3s ease;\n}\n.fade-enter-from[data-v-64a59a56], .fade-leave-to[data-v-64a59a56] {\n  transform: translateY(-20%);\n  opacity: 0;\n}\nselect[data-v-64a59a56]:disabled, input[data-v-64a59a56]:disabled {\n  background-color: #F8FAFC;\n}", ""]);
// Exports
module.exports = exports;
